export default "__VITE_ASSET__DTiIoluX__"